export default __webpack_public_path__ + "static/media/element_50.e8588067.jpg";